// ======================================================================
// File Name       : CourseEditUser
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, Col, Row, Button, Table, FormControl } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import { getItemBoxName, parseDateForDetail, displayUserAuthority, WRONG_ATTENDING_DATE_TXT } from '../../utils/index';
import { DEFAULT_DATE_FORMAT, DEFAULT_DATE_FORMAT_SHORT_DETAIL } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import DateTimeWithValidate from '../../components/DateTimeWithValidate';
import DateTimeMinMax from '../../components/DateTimeMinMax';
import SelectBox from '../../components/SelectBox';
import Pagination from '../../components/Pagination';
import { USER_TYPE } from '../../constants/UserConstants';

class CourseEditUser extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextProps.authority === this.props.authority &&
    nextProps.editingUser === this.props.editingUser &&
    nextProps.recordNumUserCourseRelation === this.props.recordNumUserCourseRelation;
    return !shouldNotUpdate;
  }

  render() {
    const {
      authority,
      editingUser,
      recordNumUserCourseRelation,
      isAdminHasCourseRelation,
      isShowMessageMaxRecord,
    } = this.props;
    this.refsToValidate = [];
    const editingUserList = Object.keys(editingUser).sort((a, b) => {
      if (editingUser[a].addNew && !editingUser[b].addNew) {
        return -1;
      } else if (!editingUser[a].addNew && editingUser[b].addNew) {
        return 1;
      }
      if (editingUser[a].index < editingUser[b].index) {
        return -1;
      } else if (editingUser[a].index > editingUser[b].index) {
        return 1;
      }
      return 0;
    });
    return (
      <div>
        <Form.Group className={isShowMessageMaxRecord ? 'form-info' : 'form-info margin-top-50'} id="scroll-table-course">
          <Col as={Form.Label} sm={6} className={isShowMessageMaxRecord ? 'margin-top-10' : 'margin-top-15'} >
            紐付け対象ユーザー
          </Col>
          <Col sm={6} className="text-right">
            { !isShowMessageMaxRecord && <Button variant="default" onClick={this.props.handleRemoveAllUserRelation}>ユーザー一括削除</Button> }
          </Col>
          <Col sm={12}>
            <Table striped hover className="margin-top-7 margin-bottom-0">
              <thead>
                <tr>
                  <th>ロール/ユーザー種別</th>
                  <th>ユーザー名</th>
                  <th>ログインID</th>
                  {/* #7230 START */}
                  <th style={{ width: 190 }}>有効期限開始日時</th>
                  <th style={{ width: 190 }}>有効期限終了日時</th>
                  {/* #7230 END */}
                  <th className="col-md-1">操作</th>
                </tr>
              </thead>
              <tbody>
                {editingUserList.map((userSecernId, index) => {
                  const courseRelationInfo = editingUser[userSecernId];
                  if (!courseRelationInfo) return null;
                  // Step 11.2.0 #17960 START
                  // Step 11.2.1 US-1528 START
                  const isAllowEditUser =
                    (!courseRelationInfo.superuserSecernId && !isAdminHasCourseRelation) ||
                    (isAdminHasCourseRelation &&
                      (isNaN(parseInt(courseRelationInfo.userType, 10)) ||
                        parseInt(courseRelationInfo.userType, 10) !== USER_TYPE.ADMIN));
                  // Step 11.2.1 US-1528 END
                  // Step 11.2.0 #17960 END
                  return (
                    <tr
                      key={index}
                      className={courseRelationInfo.addNew ? 'background_new_record' : ''}
                    >
                      <td>
                        {displayUserAuthority(courseRelationInfo, authority)}
                      </td>
                      <td>
                        {courseRelationInfo.userName}
                      </td>
                      <td>
                        {courseRelationInfo.loginId}
                      </td>
                      {/* #7230 START */}
                      <td>
                        <DateTimeWithValidate
                          dateFormat={DEFAULT_DATE_FORMAT_SHORT_DETAIL}
                          value={courseRelationInfo.attendingPeriodFrom}
                          onChange={mDate =>
                            this.props.handlePeriodTimeChange(
                              userSecernId,
                              'attendingPeriodFrom',
                              mDate ? mDate.format(DEFAULT_DATE_FORMAT_SHORT_DETAIL) : '',
                            )}
                          ref={(ref) => {
                            if (ref) {
                              this.refsToValidate.push(ref);
                            }
                          }}
                          disabled={!isAllowEditUser || isShowMessageMaxRecord}
                          className={isAllowEditUser && !isShowMessageMaxRecord ? '' : 'cursor-disable calendar-disable'}
                          showTime
                        />
                        {/* #7230 END */}
                      </td>
                      <td>
                        {/* #7230 START */}
                        <DateTimeWithValidate
                          dateFormat={DEFAULT_DATE_FORMAT_SHORT_DETAIL}
                          value={courseRelationInfo.attendingPeriodTo}
                          onChange={mDate =>
                            this.props.handlePeriodTimeChange(userSecernId, 'attendingPeriodTo',
                            mDate ? mDate.format(DEFAULT_DATE_FORMAT_SHORT_DETAIL) : '',
                            )}
                          ref={(ref) => {
                            if (ref) {
                              this.refsToValidate.push(ref);
                            }
                          }}
                          disabled={!isAllowEditUser || isShowMessageMaxRecord}
                          className={isAllowEditUser && !isShowMessageMaxRecord ? '' : 'cursor-disable calendar-disable'}
                          showTime
                        />
                        {/* #7230 END */}
                        <DateTimeMinMax
                          dateFrom={courseRelationInfo.attendingPeriodFrom}
                          dateTo={courseRelationInfo.attendingPeriodTo}
                          ref={(ref) => {
                            if (ref) {
                              this.refsToValidate.push(ref);
                            }
                          }}
                          wrongPeriodTxt={WRONG_ATTENDING_DATE_TXT}
                        />
                      </td>
                      <td className="text-center">
                        {isAllowEditUser && !isShowMessageMaxRecord &&
                        <i
                          role="button"
                          className="bi bi-trash"
                          onClick={this.props.handleRemoveUserRelation.bind(null, userSecernId)}
                        />}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default CourseEditUser;
